import {DialogProps} from '@mui/material'
import {create} from 'zustand'

const defaultModalProps: DialogProps = {
  open: false,
  children: null,
}

interface ModalState {
  modalProps: DialogProps
  setModalProps: (values: DialogProps) => void
  closeModal: () => void
}

/**
 * Zustand store for modal state.
 * Replaces ModalContext/ModalProvider.
 */
export const useModalStore = create<ModalState>()((set, get) => ({
  modalProps: {...defaultModalProps},

  closeModal: () => {
    set({modalProps: {...defaultModalProps}})
  },

  setModalProps: (values: DialogProps) => {
    const {closeModal} = get()
    set({
      modalProps: {
        ...defaultModalProps,
        onClose: closeModal,
        ...values,
      },
    })
  },
}))

// Named hook for consuming modal state and actions
export const useModal = () => useModalStore()
